module.exports = function() {
  return new Worker(__webpack_public_path__ + "aab8e13994b3e4cdd74b.worker.js");
};